export default __webpack_public_path__ + "static/media/delete.1b80a116.svg";